export const DEFAULT_DEV_HOST = "127.0.0.1";
export const DEFAULT_DEV_PORT = 3000;

export const DEFAULT_PUBLIC_SITE_URL = "http://anduongliving.test";
export const DEFAULT_API_BASE_URL = `${DEFAULT_PUBLIC_SITE_URL}/api`;
export const DEFAULT_LOCAL_BACKEND_URL = "http://127.0.0.1:8000";
